import { BrowserRouter } from "react-router-dom";

import AppProviders from "./providers/AppProviders";
import AppRoutes from "./router/routes";
import NavigationBridge from "./router/NavigationBridge";
import AppOverlays from "./ui/AppOverlays";
import useSyncMobileMode from "./hooks/useSyncMobileMode";

import "./App.scss";

const AppContent = () => {
    useSyncMobileMode();

    return (
        <>
            <NavigationBridge />
            <AppRoutes />
            <AppOverlays />
        </>
    );
};

function App() {
    return (
        <BrowserRouter>
            <AppProviders>
                <AppContent />
            </AppProviders>
        </BrowserRouter>
    );
}

export default App;
